import { render, staticRenderFns } from "./StepNeeds.vue?vue&type=template&id=6c048ea8&scoped=true&"
import script from "./StepNeeds.vue?vue&type=script&lang=js&"
export * from "./StepNeeds.vue?vue&type=script&lang=js&"
import style0 from "./StepNeeds.vue?vue&type=style&index=0&id=6c048ea8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c048ea8",
  null
  
)

export default component.exports